import { axiosInstance, CommonResponse } from ".";
import { Attachment } from "./attachment";


// 10 注册 20 登录 30 修改密码 40 绑定 50 转移管理员 60 更换手机
type codeTypeItems = 10 | 20 | 30 | 40 | 50 | 60
export const codeType: {
    [key: string]: codeTypeItems,
} = {
    register: 10, // 注册
    login: 20, // 登录
    password: 30, // 修改密码
    bind: 40, // 绑定
    transfer: 50, // 转移管理员
    changeMobile: 60 // 更换手机
};

export interface ISendVCodeForm {
    mobile: string,
    type: codeTypeItems
}

/**
 * 发送验证码
 * @param data 
 * @returns 
 */
export const sendVCode = (data: ISendVCodeForm): Promise<CommonResponse> => {
    return axiosInstance.post('/api/shares/sms_send', data).then(res => res.data);
};

export const loginType = {
    code: 1, // 验证码
    password: 2, // 密码
};

export interface ILoginForm {
    login_type: number,
    mobile: string,
    code: string,
}

export interface ILoginData {
    token: string,
}

/**
 * @description: 用户登录
 * @params {ILoginForm} params
 * @return {Promise}
 */
export const login = (data: ILoginForm): Promise<CommonResponse<ILoginData>> => {
    return axiosInstance.post('/manage/login', data).then(res => res.data);
};

export interface IUserInfo {
    id?: number,
    real_name?: string,
    mobile?: string,
    status?: number,
    avatar_id?: number,
    idcard?: string,
    dept_name?: string,
    is_register?: number,
    company_id?: number,
    company_text?: string,
    status_text?: string,
    avatar_link?: string,

    bank_no?: string,
    bank_name?: string,
    bank_deposit?: string,
    social_no?: string,
}

export interface IUserInitData {
    staff?: any,
    entry_apply?: any,
    company_apply?: any,
    mobile?: string
}

/**
 * @description: 获取用户初始化信息
 * @returns {Promise}
 */
export const getUserInitData = (): Promise<CommonResponse<IUserInitData>> => {
    return axiosInstance.get('/manage/init_data').then(res => res.data);
};

export interface IRegisterForm {
    idcard_front_img: number,
    idcard_back_img: number,
    name: string,
    nation_id: number,
    idcard: string,
    idcard_begin_date: string,
    idcard_expire_date: string,
    sex: number,
    birthday: string,
    native_province_id?: number,
    native_city_id?: number,
    native_area_id?: number,
    native_street_id?: number,
    native_address: string,
    mobile: string,
    cur_province_id: number,
    cur_city_id: number,
    cur_area_id: number,
    cur_street_id: number,
    cur_address: string,
    marry_status: number,
    is_birth: number,
    polity_face?: number,
    household_type?: number,
    email?: string,
    qq?: string,
    wechat?: string,
    bank_card_img?: number,
    bank_name?: string,
    bank_no?: string,
    edu_exp: IEduExpItem[],
    job_exp: IJobExpItem[],
    staff_img?: number,
    edu_prove_img?: number,
    social_card_img?: number,
    fund_card_img?: number,
    quit_img?: number,
    is_disease: number,
    disease_desc?: string,
    is_disability: number,
    disability_desc?: string,
    is_done_harmful_job: number,
    harmful_job_desc?: string,
    is_occupational_disease: number,
    occupational_disease_desc?: string,
    ec_name: string,
    ec_mobile: string,
    ec_relation: number,
    ec_address: string,
    company_id?: number,
    edu_level?: number,
    dept_id?: number,
    post_id?: number,
    hire_type?: number,
    contract_year?: number,
    try_month?: number,
    payday?: number,
    deduct_social_security_type?: number,
    bear_social_security_type?: number,
    is_accumulation_fund?: number,
    salary_province_id?: number,
    salary_city_id?: number,
    entry_date?: string,
    base_salary?: number,
    actual_salary?: number
}

export interface IEduExpItem {
    school: string,
    begin: string,
    end: string
}

export interface IJobExpItem {
    company: string,
    begin: string,
    end: string
}


/**
 * 注册
 * @param data 
 * @returns 
 */
export const register = (data: IRegisterForm): Promise<CommonResponse> => {
    return axiosInstance.post('/manage/entry_apply', data).then(res => res.data);
};

export interface DictItem {
    id: number
    name: string,
}

/**
 * 获取company_id
 * @param data 
 * @returns 
 */
export const getCompanyIdByCode = (data: { invition_code: string }): Promise<CommonResponse<DictItem>> => {
    return axiosInstance.get('/manage/company_info', { params: data }).then(res => res.data);
};